import script from "./LanguageButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageButton.vue?vue&type=script&setup=true&lang=js"

import "./LanguageButton.vue?vue&type=style&index=0&id=465528de&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465528de"]])

export default __exports__